<template>
    <div>
        <!-- 顶部 -->
        <div class="header">
            <i v-if="!isCollapse" class="iconfont icon-zhedie1" @click="isShowMenu"></i>
            <i v-if="isCollapse" class="iconfont icon-zhedie2" @click="isShowMenu"></i>
            <b v-if="userName.length > 0" class="hello">欢迎您，{{  userName }}</b>
            <button class="logOutBtn" @click="logOut">注销</button>
        </div>
        <!-- 内容 -->
        <div class="wrapper">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { RouterView } from 'vue-router';
export default {
    props:['isCollapse'],
    data() {
        return {
            menuIcon: '',
            userName:JSON.parse(localStorage.getItem('userName'))[0].userName

        }
    },
    methods: {
        isShowMenu() {
            console.log(localStorage)
            this.$emit('changeShow')
        },
        logOut(){
            localStorage.clear();
            this.$router.push('/Login')
        }
    }
}
</script>

<style scoped>
.header{
    height: 50px;
    background-color: #1e78bf;
    color: #fff;
    line-height: 50px;
    .iconfont{
        font-size: 22px;
        cursor: pointer;
    }
}
.wrapper{
    padding: 20px;
}
.hello{
    margin-left: 80%;
}
.logOutBtn{
    background-color:dodgerblue;
	            color:white;
	            width: 60px;
	            height: 40px;
	            border:0;
	            font-size: 16px;
	            box-sizing: content-box;				
                border-radius: 5px;
                margin-left: 20px;
}

</style>